import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "messaging"
    }}>{`Messaging`}</h1>
    <p>{`These are the guidelines and best practices on when and how to provide users with feedback as they interact with your plugin.`}</p>
    <ul>
      <li parentName="ul">{`Alerts`}</li>
      <li parentName="ul">{`Success`}</li>
      <li parentName="ul">{`Output`}</li>
      <li parentName="ul">{`Permission dialogs`}</li>
      <li parentName="ul">{`Loaders and Progress Indicators`}</li>
      <li parentName="ul">{`Examples`}</li>
    </ul>
    <p>{`Provide users with feedback as they interact with your plugin. This can be alert and success messaging, permission dialogs, or loaders or progress bars to let them know that something is running in the background. `}</p>
    <p>{`Here is a guide to help you determine where to render plugin messages:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "98.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/cb523/Messaging-1.webp 320w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/797b9/Messaging-1.webp 640w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/4b075/Messaging-1.webp 1280w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/f3ff0/Messaging-1.webp 1920w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/09431/Messaging-1.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/72799/Messaging-1.png 320w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/6af66/Messaging-1.png 640w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/21b4d/Messaging-1.png 1280w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/29114/Messaging-1.png 1920w", "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/20a65/Messaging-1.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/63f9958680b56bccd382d221a18ade72/21b4d/Messaging-1.png",
            "alt": "This shows the different ways you can provide feedback to the user through messaging",
            "title": "This shows the different ways you can provide feedback to the user through messaging",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Open this image in a new tab in your browser in order to zoom in on it.`}</p>
    <h2 {...{
      "id": "alerts"
    }}>{`Alerts`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`Use alert messaging whenever the plugin cannot perform the intended task, dialogs are persistent until dismissed`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/cb523/Alert-Requirements.webp 320w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/797b9/Alert-Requirements.webp 640w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/4b075/Alert-Requirements.webp 1280w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/f3ff0/Alert-Requirements.webp 1920w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/09431/Alert-Requirements.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/72799/Alert-Requirements.png 320w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/6af66/Alert-Requirements.png 640w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/21b4d/Alert-Requirements.png 1280w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/29114/Alert-Requirements.png 1920w", "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/20a65/Alert-Requirements.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/09f217d388e1be5ba93320d670efe41a/21b4d/Alert-Requirements.png",
            "alt": "This shows the alert dialog requirements",
            "title": "This shows the alert dialog requirements",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Header`}</strong><br parentName="p"></br>{`
`}{`Have a clear header that describes the error`}</p>
    <p><strong parentName="p">{`Message`}</strong><br parentName="p"></br>{`
`}{`Explain what error was encountered and give a clear actionable solution. Also, avoid blaming the user or the application.`}</p>
    <p><strong parentName="p">{`Dialog buttons`}</strong><br parentName="p"></br>{`
`}{`Include at least one modal dismissal button to allow the user to dismiss/close the modal`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/cb523/Alert-Recommendations.webp 320w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/797b9/Alert-Recommendations.webp 640w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/4b075/Alert-Recommendations.webp 1280w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/f3ff0/Alert-Recommendations.webp 1920w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/09431/Alert-Recommendations.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/72799/Alert-Recommendations.png 320w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/6af66/Alert-Recommendations.png 640w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/21b4d/Alert-Recommendations.png 1280w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/29114/Alert-Recommendations.png 1920w", "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/20a65/Alert-Recommendations.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/9fd378fbbae406be9024512c75f7f145/21b4d/Alert-Recommendations.png",
            "alt": "This shows the alert dialog best practices",
            "title": "This shows the alert dialog best practices",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h4>
    <p><strong parentName="p">{`Warning icon`}</strong><br parentName="p"></br>{`
`}{`To help communicate critical information for an error you can include a warning icon next to the header`}</p>
    <p><strong parentName="p">{`Help`}</strong><br parentName="p"></br>{`
`}{`If a plugin has a help page, consider adding it to the error modal dialog.`}</p>
    <p><strong parentName="p">{`Visual/tutorials`}</strong><br parentName="p"></br>{`
`}{`Provide image/GIF example as part of the dialog, to help users understand the actionable solution`}</p>
    <p><strong parentName="p">{`Messaging`}</strong><br parentName="p"></br>{`
`}{`In the alert messages use language that is easy to understand for the user.`}</p>
    <h2 {...{
      "id": "success"
    }}>{`Success`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`Use success messaging whenever the plugin successfully completes a task and has no visual output on the canvas.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/cb523/success-Requirements.webp 320w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/797b9/success-Requirements.webp 640w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/4b075/success-Requirements.webp 1280w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/f3ff0/success-Requirements.webp 1920w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/09431/success-Requirements.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/72799/success-Requirements.png 320w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/6af66/success-Requirements.png 640w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/21b4d/success-Requirements.png 1280w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/29114/success-Requirements.png 1920w", "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/20a65/success-Requirements.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/db95d2e3d2ebea4badf662a7657ade6c/21b4d/success-Requirements.png",
            "alt": "This shows the alert success dialog example",
            "title": "This shows the alert success dialog example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements-1"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Header`}</strong><br parentName="p"></br>{`
`}{`Have a clear header for the dialog.`}</p>
    <p><strong parentName="p">{`Message`}</strong><br parentName="p"></br>{`
`}{`Explain what the plugin successfully completed, if it is not visually apparent to the user.`}</p>
    <p><strong parentName="p">{`Dialog buttons`}</strong><br parentName="p"></br>{`
`}{`Include at least one modal dismissal button to allow the user to dismiss/close the modal.`}</p>
    <h2 {...{
      "id": "output"
    }}>{`Output`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`If a plugin generates output that the user needs to complete a workflow, then the plugin needs to provide that information to the user through an interface.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "83.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/cb523/Plugin-output.webp 320w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/797b9/Plugin-output.webp 640w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/4b075/Plugin-output.webp 1280w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/f3ff0/Plugin-output.webp 1920w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/09431/Plugin-output.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/72799/Plugin-output.png 320w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/6af66/Plugin-output.png 640w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/21b4d/Plugin-output.png 1280w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/29114/Plugin-output.png 1920w", "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/20a65/Plugin-output.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/70d612f69ceedf205995fcd6b321ca81/21b4d/Plugin-output.png",
            "alt": "This shows the plugin output example",
            "title": "This shows the plugin output example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements-2"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Plugin output`}</strong><br parentName="p"></br>{`
`}{`In use cases like these, the plugin output can be shown in the interface, copied onto the clipboard, populated on the document or generate a file.`}</p>
    <p><strong parentName="p">{`Example:`}</strong><br parentName="p"></br>{`
`}{`Copied onto the clipboard - the plugin can add copy to the clipboard and provides the user with instructions through the interface.`}</p>
    <p><strong parentName="p">{`Don’t`}</strong><br parentName="p"></br>{`
`}{`Require users to go into the developer console to complete an action.`}</p>
    <h2 {...{
      "id": "permission-dialogs"
    }}>{`Permission dialogs`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`Use permission dialogs when being destructive or making modifications.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/cb523/Permission-dialog-example.webp 320w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/797b9/Permission-dialog-example.webp 640w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/4b075/Permission-dialog-example.webp 1280w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/f3ff0/Permission-dialog-example.webp 1920w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/09431/Permission-dialog-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/72799/Permission-dialog-example.png 320w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/6af66/Permission-dialog-example.png 640w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/21b4d/Permission-dialog-example.png 1280w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/29114/Permission-dialog-example.png 1920w", "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/20a65/Permission-dialog-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/07b7d018cc085d098aaeb5fad1dc8d71/21b4d/Permission-dialog-example.png",
            "alt": "This shows a permission dialog example",
            "title": "This shows a permission dialog example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements-3"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Header`}</strong><br parentName="p"></br>{`
`}{`Have a clear header for the dialog.`}</p>
    <p><strong parentName="p">{`Message`}</strong><br parentName="p"></br>{`
`}{`Explain the destructive action or modification and ask for the user’s permission`}</p>
    <p><strong parentName="p">{`Dialog buttons`}</strong><br parentName="p"></br>{`
`}{`Include a modal dismissal button to allow the user to cancel/close the modal and a negative button (red) to highlight that action.`}</p>
    <p><strong parentName="p">{`Key Commands`}</strong><br parentName="p"></br>{`
`}{`Esc key or Enter key Dismisses the dialog when the “Cancel” button is in focus`}</p>
    <h2 {...{
      "id": "loaders-and-progress-indicators"
    }}>{`Loaders and Progress Indicators`}</h2>
    <p>{`Let the user know when something is happening in the background in the plugin interface. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/cb523/progress-bar-example.webp 320w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/797b9/progress-bar-example.webp 640w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/4b075/progress-bar-example.webp 1280w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/f3ff0/progress-bar-example.webp 1920w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/09431/progress-bar-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/72799/progress-bar-example.png 320w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/6af66/progress-bar-example.png 640w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/21b4d/progress-bar-example.png 1280w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/29114/progress-bar-example.png 1920w", "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/20a65/progress-bar-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/cb2230b02eaac062817050a01daa037a/21b4d/progress-bar-example.png",
            "alt": "This shows a progress bar example",
            "title": "This shows a progress bar example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "best-practices-1"
    }}>{`Best practices`}</h4>
    <p><strong parentName="p">{`Progress bar`}</strong><br parentName="p"></br>{`
`}{`Progress bars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way. They can represent either determinate or indeterminate progress.`}</p>
    <p><a parentName="p" {...{
        "href": "https://spectrum.adobe.com/page/progress-bar/"
      }}>{`Spectrum Progress bar guidelines`}</a></p>
    <p><strong parentName="p">{`Progress circle`}</strong><br parentName="p"></br>{`
`}{`Progress circles show the progression of a system operation such as downloading, uploading, processing, etc. in a visual way. They can represent determinate or indeterminate progress.`}</p>
    <p><a parentName="p" {...{
        "href": "https://spectrum.adobe.com/page/progress-bar/"
      }}>{`Spectrum Progress circle guidelines`}</a></p>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/4516eee133760022f585cdec8477f622/cb523/Error-alert-example.webp 320w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/797b9/Error-alert-example.webp 640w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/4b075/Error-alert-example.webp 1280w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/f3ff0/Error-alert-example.webp 1920w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/09431/Error-alert-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/4516eee133760022f585cdec8477f622/72799/Error-alert-example.png 320w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/6af66/Error-alert-example.png 640w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/21b4d/Error-alert-example.png 1280w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/29114/Error-alert-example.png 1920w", "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/20a65/Error-alert-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/4516eee133760022f585cdec8477f622/21b4d/Error-alert-example.png",
            "alt": "This shows an alert example for an operation that failed to complete",
            "title": "This shows an alert example for an operation that failed to complete",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Operation failed to complete`}</strong><br parentName="p"></br>{`
`}{`Error dialog - when a plugin can’t complete an operation, render an error dialog to let the user know the operation failed and why it failed.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/cb523/Alert-Information-example-2.webp 320w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/797b9/Alert-Information-example-2.webp 640w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/4b075/Alert-Information-example-2.webp 1280w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/f3ff0/Alert-Information-example-2.webp 1920w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/09431/Alert-Information-example-2.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/72799/Alert-Information-example-2.png 320w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/6af66/Alert-Information-example-2.png 640w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/21b4d/Alert-Information-example-2.png 1280w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/29114/Alert-Information-example-2.png 1920w", "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/20a65/Alert-Information-example-2.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/8246932a2e2718c7dba4178ea08a92dd/21b4d/Alert-Information-example-2.png",
            "alt": "This shows an alert example for a network connectivity issue",
            "title": "This shows an alert example for a network connectivity issue",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Network connectivity issue`}</strong><br parentName="p"></br>{`
`}{`Information dialog - if the plugin is unable to connect to the internet to complete an action, then use an information modal dialog to communicate that to the user.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/cb523/Messaging-example.webp 320w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/797b9/Messaging-example.webp 640w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/4b075/Messaging-example.webp 1280w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/f3ff0/Messaging-example.webp 1920w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/09431/Messaging-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/72799/Messaging-example.png 320w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/6af66/Messaging-example.png 640w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/21b4d/Messaging-example.png 1280w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/29114/Messaging-example.png 1920w", "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/20a65/Messaging-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/72ecc3d5371f5e3f379216817d650c67/21b4d/Messaging-example.png",
            "alt": "This shows a message example",
            "title": "This shows a message example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Unable to share`}</strong><br parentName="p"></br>{`
`}{`“An error occurred while sharing your project. Please verify the email. address and try again”.`}</p>
    <p><strong parentName="p">{`Network connectivity`}</strong><br parentName="p"></br>{`
`}{`“Please connect to WiFi to sync your tasks to your product management tool”.`}</p>
    <h4 {...{
      "id": "panel-ui-messaging"
    }}>{`Panel UI messaging`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "71.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/cb523/panel-messaging-example.webp 320w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/797b9/panel-messaging-example.webp 640w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/4b075/panel-messaging-example.webp 1280w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/f3ff0/panel-messaging-example.webp 1920w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/09431/panel-messaging-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/72799/panel-messaging-example.png 320w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/6af66/panel-messaging-example.png 640w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/21b4d/panel-messaging-example.png 1280w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/29114/panel-messaging-example.png 1920w", "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/20a65/panel-messaging-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/707dd0846fcc82d1a646838c8dcab03c/21b4d/panel-messaging-example.png",
            "alt": "This shows a panel messaging example",
            "title": "This shows a panel messaging example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      